import React, { RefObject } from "react";
import styles from "./DesktopLayout.module.scss";
import { Dial } from "../Dial/Dial";
import { Years } from "../Years/Years";
import { Controls } from "../Controls/Controls";
import { Events } from "../Events/Events";
import { TimelineEvent } from "../../model/data";

interface Period {
  id: number;
  title: string;
}

interface DesktopLayoutProps {
  total: number;
  periodIndex: number;
  dialRotation: number;
  groupRotation: number;
  periods: Period[];
  transitioningToIndex: number | null;
  isLabelVisible: boolean;
  yearLeft: number;
  yearRight: number;
  events: TimelineEvent[];
  activeSlideIndex: number;
  onSlideChange: (index: number) => void;
  count: string;
  onPeriodPrev: () => void;
  onPeriodNext: () => void;
  onDotClick: (index: number) => void;
  setDotRef: (index: number, el: HTMLButtonElement | null) => void;
  isNextDisabled?: boolean;
  isAnimating?: boolean;
  dotsGroupRef: RefObject<HTMLDivElement>;
  yearsRef: RefObject<HTMLDivElement>;
}

export const DesktopLayout: React.FC<DesktopLayoutProps> = ({
  total,
  periodIndex,
  dialRotation,
  groupRotation,
  periods,
  transitioningToIndex,
  isLabelVisible,
  yearLeft,
  yearRight,
  events,
  activeSlideIndex,
  onSlideChange,
  count,
  onPeriodPrev,
  onPeriodNext,
  onDotClick,
  setDotRef,
  isNextDisabled,
  isAnimating = false,
  dotsGroupRef,
  yearsRef,
}) => {
  return (
    <main className={styles.page}>
      <section className={styles.stage}>
        <div className={styles.container}>
          <header className={styles.header}>
            <h1 className={styles.title}>
              <span className={styles.titleAccent} aria-hidden="true" />
              <span className={styles.titleText}>
                Исторические
                <br />
                даты
              </span>
            </h1>
          </header>

          <div className={styles.dialSlot} aria-hidden="true">
            <div className={styles.dialWrap}>
              <Dial
                ref={dotsGroupRef}
                total={total}
                activeIndex={periodIndex}
                rotation={dialRotation}
                groupRotation={groupRotation}
                onDotClick={onDotClick}
                isAnimating={isAnimating}
                anchorDeg={-60}
                periods={periods}
                transitioningToIndex={transitioningToIndex}
                isLabelVisible={isLabelVisible}
                setDotRef={setDotRef}
              />

              <div className={styles.yearsOverlay}>
                <Years ref={yearsRef} yearLeft={yearLeft} yearRight={yearRight} />
              </div>
            </div>
          </div>

          <div className={styles.center} />
          <footer className={styles.footer}>
            <div className={styles.controlsArea}>
              <Controls
                count={count}
                onPrev={onPeriodPrev}
                onNext={onPeriodNext}
                canPrev={periodIndex > 0}
                canNext={periodIndex < total - 1}
                isAnimating={isAnimating}
              />
            </div>

            <div className={styles.eventsArea}>
              <Events
                events={events}
                currentSlideIndex={activeSlideIndex}
                onSlideChange={onSlideChange}
                resetKey={periodIndex}
                isAnimating={isAnimating}
              />
            </div>
          </footer>
        </div>
      </section>
    </main>
  );
};

